import {
  createEditorPlatformContextError,
  EditorPlatformContextErrorCode,
} from '../errors';

import { ApplicationBoundEvents } from '../ApplicationBoundEvents';
import { EnvironmentContext } from './EnvironmentContext';
import { ContextInjectionStatus } from './ContextInjectionStatus';

export const APPLICATION_CONTEXT_KEY = '__APPLICATION_CONTEXT_KEY';
declare global {
  // eslint-disable-next-line no-var
  var __APPLICATION_CONTEXT_KEY: ApplicationContext;
}

/**
 * renamed: IApplicationContext
 * there is no sense to split context by application type or running context
 * - addon
 * - application
 * - builder component
 * - panel or whatever
 * sdk context should be a union of all available options
 */
export interface IPlatformSDKContext {
  manifestContextId?: string | null;
  appDefinitionId?: string | null;
  /**
   * TODO: get rid of data prop, use root props
   */
  data?: {
    toolPanelConfig: {
      url: string;
      width: string;
      height: string;
      initialPosition: {
        x: string;
        y: string;
      };
    };
  };
}

export class ApplicationContext {
  private static status = new ContextInjectionStatus('application');

  /**
   * TODO: use generics for context type
   * - application
   * - editor
   */
  static async inject(context: IPlatformSDKContext) {
    // const environment = await EnvironmentContext.getInstance();

    // if (environment.getEnvironment() !== PlatformEnvironment.Frame) {
    //   throw createEditorPlatformContextError(
    //     EditorPlatformContextErrorCode.IncorrectEnvironment,
    //     'Application context can be injected only in frame environment',
    //   );
    // }

    if (globalThis[APPLICATION_CONTEXT_KEY]) {
      throw createEditorPlatformContextError(
        EditorPlatformContextErrorCode.IncorrectEnvironment,
        'Application context already exists and should not be overridden',
      );
    }

    globalThis[APPLICATION_CONTEXT_KEY] = new ApplicationContext(
      context,
      await EnvironmentContext.getInstance(),
    );

    this.status.resolveInjected();
  }

  static async getInstance() {
    if (typeof __APPLICATION_CONTEXT_KEY !== 'undefined') {
      /**
       * NOTE it is taken not from global
       * __APPLICATION_CONTEXT_KEY is the variable which set during
       * application bundle execution using new Function() approach
       */
      return __APPLICATION_CONTEXT_KEY as ApplicationContext;
    }

    await this.status.waitInjected();

    return globalThis[APPLICATION_CONTEXT_KEY] as ApplicationContext;

    // const environment = await EnvironmentContext.getInstance();

    // if (environment.getEnvironment() === PlatformEnvironment.Frame) {
    //   await this.status.waitInjected();
    //   return globalThis[
    //     APPLICATION_CONTEXT_KEY
    //   ] as ApplicationContext<TContext>;
    // } else {
    //   /**
    //    * NOTE it is taken not from global
    //    * __APPLICATION_CONTEXT_KEY is the variable which set during
    //    * application bundle execution using new Function() approach
    //    */
    //   return __APPLICATION_CONTEXT_KEY as ApplicationContext<TContext>;
    // }
  }

  private events: ApplicationBoundEvents;

  constructor(
    private context: IPlatformSDKContext,
    private environment: EnvironmentContext,
  ) {
    this.events = new ApplicationBoundEvents(
      context.appDefinitionId ? context.appDefinitionId : null,
      this.environment.getEvents(),
      this.environment.getPrivateAPI(),
    );
  }

  getContext() {
    return this.context;
  }

  getAppDefinitionId() {
    return this.context.appDefinitionId;
  }

  getManifestContextId() {
    return this.context.manifestContextId;
  }

  getEvents() {
    return this.events;
  }

  getEnvironmentContext() {
    return this.environment;
  }

  getPrivateAPI() {
    return this.environment.getPrivateAPI();
  }

  getPrivateApplicationAPI() {
    const appDefinitionId = this.getAppDefinitionId();

    if (!appDefinitionId) {
      throw createEditorPlatformContextError(
        EditorPlatformContextErrorCode.IncorrectEnvironment,
        'appDefinitionId is not available',
      );
    }

    return this.environment.getApplicationAPIs()[appDefinitionId];
  }
}
